module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Once-Upon-A-Time-In-Venice.40554ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Once-Upon-A-Time-In-Venice.jpg
// module id = TF8s
// module chunks = 0